import React, { useCallback, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { createSipRuntime, executeUiAction } from "../runtime/sipRuntime"

const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

const variantClass = (variant) => {
  switch (variant) {
    case "primary":
      return "sn-btn sn-btn--primary";
    case "danger":
      return "sn-btn sn-btn--danger";
    case "ghost":
      return "sn-btn sn-btn--ghost";
    case "success":
      return "sn-btn sn-btn--primary";
    default:
      return "sn-btn sn-btn--neutral";
  }
};

const UiActionButton = ({ action, onRun }) => (
  <button
    type="button"
    className={variantClass(action.sip_variant)}
    title={action.sip_tooltip || ""}
    onClick={() => onRun(action)}
  >
    {action.sip_icon ? `${action.sip_icon} ` : ""}
    {action.sip_label || action.sip_name}
  </button>
);

const UiActionBar = ({
  tableName,
  recordId,
  record,
  setRecord,
  token,
  apiBaseUrl,
  navigate,
  handleSave,
  loadForm,
}) => {
  const [actions, setActions] = useState([]);

  const loadActions = useCallback(async () => {
    if (!tableName || !token) return;

    const res = await axios.post(
      `${apiBaseUrl}/ui-actions/visible`,
      {
        table_name: tableName,
        view_type: "form",
        record_id: recordId,
        selected_ids: [],
      },
      { headers: authHeaders(token) }
    );

    setActions(res.data?.actions || []);
  }, [apiBaseUrl, recordId, tableName, token]);

  useEffect(() => {
    loadActions().catch((error) => {
      console.error("Failed to load UI actions:", error);
    });
  }, [loadActions]);

  const grouped = useMemo(() => {
    const sorted = [...actions].sort(
      (a, b) => (a.sip_sort_order || 100) - (b.sip_sort_order || 100)
    );

    return {
      primary: sorted.filter((a) => a.sip_position === "primary"),
      secondary: sorted.filter((a) => a.sip_position === "secondary"),
      more: sorted.filter((a) => !["primary", "secondary"].includes(a.sip_position)),
    };
  }, [actions]);

  const runAction = async (action) => {
    const sip = createSipRuntime({
      tableName,
      recordId,
      record,
      setRecord,
      token,
      apiBaseUrl,
      navigate,
      handleSave,
      loadForm,
    });

    await executeUiAction(action, sip);
  };

  return (
    <>
      {grouped.primary.map((action) => (
        <UiActionButton key={action.id} action={action} onRun={runAction} />
      ))}

      {grouped.secondary.map((action) => (
        <UiActionButton key={action.id} action={action} onRun={runAction} />
      ))}
    </>
  );
};

export default UiActionBar;